import { carouselItems } from '@/mocks/home';

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-16 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <span className="inline-flex items-center gap-1.5 bg-accent-100 text-accent-700 text-xs font-semibold px-3 py-1 rounded-full mb-4">
            <i className="ri-focus-2-line text-sm"></i>
            专题聚焦
          </span>
          <h2 className="text-3xl md:text-4xl font-bold text-foreground-950 font-heading mb-3">
            本周焦点
          </h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-lg mx-auto">
            编辑精选的深度专题报道，带你全面了解娱乐圈大事件
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {carouselItems.map((item) => (
            <div
              key={item.id}
              className="bg-background-50 rounded-2xl overflow-hidden border border-background-200 cursor-pointer transition-all duration-300 hover:-translate-y-1 hover:shadow-lg group"
            >
              <div className="aspect-[3/2] overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                  loading="lazy"
                />
              </div>
              <div className="p-5">
                <div className="flex items-center gap-2 mb-2">
                  <span className="bg-accent-100 text-accent-700 text-xs font-medium px-2 py-0.5 rounded-full">
                    {item.tag}
                  </span>
                  <span className="text-foreground-400 text-xs">
                    <i className="ri-eye-line mr-1"></i>{item.reads}阅读
                  </span>
                </div>
                <h3 className="text-foreground-950 text-base font-bold mb-2 line-clamp-2 group-hover:text-primary-600 transition-colors">
                  {item.title}
                </h3>
                <p className="text-foreground-500 text-xs leading-relaxed line-clamp-3">
                  {item.summary}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}